import React from 'react';
import IForm from '../../../../types/IForm';
import { AttachedFilesBaseSortableList } from '../../AttachedFilesBase';
import { IFileItem } from '../../../../types/api/FileItem';
import { PostsEditorWithUpload } from './PostsEditorWithUpload';
import { useSonTranslation } from '../../../../translation/useSonTranslation';

type PostsEditorWithUploadAndAttachedFiles = PostsEditorWithUpload & {
  attachments?: IFileItem[];
  attachedFileUpdateOrder?: IForm;
};

/**
 * Wrapper for the Posts RichText Editor with Upload and the websocket connected AttachedFiles
 */
export function PostsEditorWithUploadAndAttachedFiles({
  form,
  attachments,
  attachedFileUpdateOrder,
  postId,
  type,
}: PostsEditorWithUploadAndAttachedFiles) {
  const { t } = useSonTranslation('Posts');

  return (
    <>
      <PostsEditorWithUpload postId={postId} form={form} type={type} autoFocus />
      {attachments && attachments.length > 0 && (
        <div className="posts__attachements-container-edit">
          <AttachedFilesBaseSortableList
            headline={t('default.attachedfiles.headline.uploaded')}
            attachedFileUpdateOrder={attachedFileUpdateOrder}
            attachments={attachments}
            hideNoAttachmentsMessage
            backgroundTransparent
            postId={postId}
          />
        </div>
      )}
    </>
  );
}
